import { useEffect, useState } from 'react';
import { useConfig } from 'shared/config/ConfigContext';
import useFetch from 'shared/hooks/useFetch';
import { queryString } from 'shared/util/query';
import type { Filters, ResultData } from '@/domain';
import { initialState } from '@/store/reducer';
import { apiListAdImageWrapper } from '@/utils/urlPrepender';

export const useSearchResultsWithPricesRegular = (searchId: string, filters: Filters) => {
    const { reactiveApiExternalUrl } = useConfig();
    const [loading, setLoading] = useState(true);
    const { destination: _unused, booking_from: _unused2, booking_to: _unused3, ...filtersWithoutDestination } = filters;

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 30000);
    }, [searchId]);

    const { data, error } = useFetch<ResultData>({
        url: `${reactiveApiExternalUrl}/reactive/page/${searchId}${queryString(filtersWithoutDestination)}`,
        options: {
            refreshInterval: (data) => {
                if (loading && !data?.completed) {
                    return 1000;
                }
                return 0;
            },
        },
    });

    return { data: apiListAdImageWrapper(data ?? initialState.results.data), error, loading: loading && !data?.completed };
};
